<template>
  <div v-if="filterType">
    <v-text-field
      v-if="filterType.startsWith('TEXT_') || filterType.startsWith('MULTI_')"
      v-model="filterValue"
      @input="onInput"
      v-bind="$attrs"
      :label="value.name"
    ></v-text-field>

    <DateTimePickerField
      v-if="filterType.startsWith('DATE_')"
      v-model="filterValue"
      @input="onInput"
      v-bind="$attrs"
      :label="value.name"
      onlyDate
      format="MM/DD/YYYY"
      returnFormat="YYYY-MM-DD"
    ></DateTimePickerField>

    <DateTimePickerField
      v-if="filterType.startsWith('DATETIME_')"
      v-model="filterValue"
      @input="onInput"
      v-bind="$attrs"
      :label="value.name"
      defaultTime="00:00"
    ></DateTimePickerField>

    <ClaimTypeField
      v-if="filterType == 'CLAIM_TYPE'"
      showKey
      v-model="filterValue"
      @input="onInput"
      v-bind="$attrs"
      :label="value.name"
    />

    <OrganizationField
      v-if="filterType == 'ORGANIZATION'"
      showKey
      v-model="filterValue"
      @input="onInput"
      v-bind="$attrs"
      :label="value.name"
    />

    <OrganizationTypeField
      v-if="filterType == 'ORGANIZATION_TYPE'"
      showKey
      v-model="filterValue"
      @input="onInput"
      v-bind="$attrs"
      :label="value.name"
    />

    <ParticipantField
      v-if="filterType == 'PARTICIPANT'"
      showKey
      v-model="filterValue"
      @input="onInput"
      v-bind="$attrs"
      :label="value.name"
    />

    <ParticipantTypeField
      v-if="filterType == 'PARTICIPANT_TYPE'"
      showKey
      v-model="filterValue"
      @input="onInput"
      v-bind="$attrs"
      :label="value.name"
    />

    <div v-if="filterType == 'ENTITY' && entityType">
      <FiscalYearField
        v-if="entityType == 'FISCAL_YEAR'"
        v-model="filterObjectValue"
        @input="onFiscalYearInput"
        v-bind="$attrs"
        :label="value.name"
        :client="selectedClient"
        clearable
        :numberOfPastYears="5"
        :numberOfFutureYears="1"
        disableAutoSelect
      />

      <ClaimStageTypeField
        v-if="entityType == 'CLAIM_STAGE_TYPE'"
        v-model="filterObjectValue"
        @input="onEnumSingleInput"
        v-bind="$attrs"
        :label="value.name"
      />

      <PromotionsField
        v-if="entityType == 'PROMOTIONS'"
        v-model="filterObjectValue"
        @input="onEntityMultiInput"
        v-bind="$attrs"
        :label="value.name"
      />

      <PromotionTypesField
        v-if="entityType == 'PROMOTION_TYPES'"
        v-model="filterObjectValue"
        @input="onEntityMultiInput"
        v-bind="$attrs"
        :label="value.name"
        disableAutoSelect
      />

      <OrganizationsField
        v-if="entityType == 'ORGANIZATIONS'"
        v-model="filterObjectValue"
        @input="onEntityMultiInput"
        v-bind="$attrs"
        :label="value.name"
      />

      <OrganizationTypesField
        v-if="entityType == 'ORGANIZATION_TYPES'"
        v-model="filterObjectValue"
        @input="onEntityMultiInput"
        v-bind="$attrs"
        :label="value.name"
      />

      <ParticipantsField
        v-if="entityType == 'PARTICIPANTS'"
        v-model="filterObjectValue"
        @input="onEntityMultiInput"
        v-bind="$attrs"
        :label="value.name"
      />

      <ParticipantTypesField
        v-if="entityType == 'PARTICIPANT_TYPES'"
        v-model="filterObjectValue"
        @input="onEntityMultiInput"
        v-bind="$attrs"
        :label="value.name"
      />

      <ProductsField
        v-if="entityType == 'PRODUCTS'"
        v-model="filterObjectValue"
        @input="onEntityMultiInput"
        v-bind="$attrs"
        :label="value.name"
      />

      <AwardVehiclesField
        v-if="entityType == 'AWARD_VEHICLES'"
        v-model="filterObjectValue"
        @input="onEntityMultiInput"
        v-bind="$attrs"
        :label="value.name"
      />

      <ClaimTypesField
        v-if="entityType == 'CLAIM_TYPES'"
        v-model="filterObjectValue"
        @input="onEntityMultiInput"
        v-bind="$attrs"
        :label="value.name"
      />

      <ClaimStageField
        v-if="entityType == 'CLAIM_STAGES' && claimTypes.length"
        v-model="filterObjectValue"
        @input="onClaimStageInput"
        :claim-types="claimTypes"
        v-bind="$attrs"
        :label="value.name"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DateTimePickerField from "./DateTimePickerField.vue";
import ClaimTypeField from "./ClaimTypeField.vue";
import OrganizationTypeField from "./OrganizationTypeField.vue";
import ParticipantTypeField from "./ParticipantTypeField.vue";
import OrganizationField from "./OrganizationField.vue";
import ParticipantField from "./ParticipantField.vue";
import FiscalYearField from "./FiscalYearField.vue";
import ClaimStageTypeField from "./ClaimStageTypeField.vue";
import PromotionsField from "./PromotionsField.vue";
import PromotionTypesField from "./PromotionTypesField.vue";
import OrganizationsField from "./OrganizationsField.vue";
import OrganizationTypesField from "./OrganizationTypesField.vue";
import ParticipantsField from "./ParticipantsField.vue";
import ParticipantTypesField from "./ParticipantTypesField.vue";
import ProductsField from "./ProductsField.vue";
import AwardVehiclesField from "./AwardVehiclesField.vue";
import ClaimTypesField from "./ClaimTypesField.vue";
import ClaimStageField from "@/gapp-components/components/fields/ClaimStageField.vue";
import ClaimTypeService from "@/gapp-components/services/claimType.service.js";

export default {
  components: {
    ParticipantField,
    OrganizationField,
    ParticipantTypeField,
    OrganizationTypeField,
    ClaimTypeField,
    DateTimePickerField,
    FiscalYearField,
    ClaimStageTypeField,
    PromotionsField,
    PromotionTypesField,
    OrganizationsField,
    OrganizationTypesField,
    ParticipantsField,
    ParticipantTypesField,
    ProductsField,
    AwardVehiclesField,
    ClaimTypesField,
    ClaimStageField
  },
  name: "CustomReportFilterFormField",
  props: {
    value: Object
  },
  data: () => ({
    filterType: null,
    filterValue: "",
    entityType: null,
    filterObjectValue: null,
    claimTypes: []
  }),
  methods: {
    syncFilterState() {
      this.filterType = this.value && this.value.filterType ? this.value.filterType.name : "";
      this.filterValue = this.value.value;
      this.entityType = this.value && this.value.entityType ? this.value.entityType.name : null;
      this.filterObjectValue = this.value.objectValue || null;

      if (this.entityType === "CLAIM_STAGES") {
        this.fetchClaimTypes();
      } else {
        this.claimTypes = [];
      }
    },

    async fetchClaimTypes() {
      this.claimTypes = await ClaimTypeService.findAll({ isEffective: "Active" });
    },

    onInput() {
      this.value.value = this.filterValue;
      this.$emit("input", this.value);
    },
    onFiscalYearInput(year) {
      this.value.value = year != null ? String(year) : null;
      this.filterObjectValue = year;
      this.$emit("input", this.value);
    },
    onEnumSingleInput(obj) {
      this.value.value = obj && obj.name ? obj.name : null;
      this.filterObjectValue = obj;
      this.$emit("input", this.value);
    },
    onClaimStageInput(claimStage) {
      this.value.value = claimStage ? claimStage.name : null;
      this.value.displayValue = claimStage ? claimStage.name : null;
      this.filterObjectValue = claimStage;
      this.$emit("input", this.value);
    },
    onEntityMultiInput(arr) {
      if (arr && arr.length > 0) {
        this.value.value = arr
          .map(function(item) {
            return item.id;
          })
          .join(",");
        this.value.displayValue = arr
          .map(function(item) {
            return item.fullName || item.name;
          })
          .join(", ");
      } else {
        this.value.value = null;
        this.value.displayValue = null;
      }
      this.filterObjectValue = arr;
      this.$emit("input", this.value);
    }
  },
  computed: {
    ...mapGetters(["selectedClient"])
  },
  watch: {
    value() {
      this.syncFilterState();
    }
  },
  created() {
    this.syncFilterState();
  }
};
</script>
